import { songFitsPlayMode, type PlayModeConfig } from '../services/playModes';
import type { SongRequest } from '../services/requests';

export function partitionForImport(
  requests: SongRequest[],
  mode: PlayModeConfig,
): { fits: SongRequest[]; unmatched: SongRequest[] } {
  const fits: SongRequest[] = [];
  const unmatched: SongRequest[] = [];
  for (const request of requests) {
    if (songFitsPlayMode(request, mode)) fits.push(request);
    else unmatched.push(request);
  }
  return { fits, unmatched };
}
